import React, { createContext, Suspense, useContext, useMemo } from 'react';
import SportsDistrictProvider from '../../../projectSpecific/sports/cnr/contexts/SportsDistrictContext';
import SportsOrganizationProvider from '../../../projectSpecific/sports/cnr/contexts/SportsOrganizationContext';
import SportsSeasonProvider from '../../../projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import SuspenseDimmer from '../../components/alerts/SuspenseDimmer';
import { gEnums } from '../../enums/globalEnums';
import { ParentContext } from './ParentContext';
import TrackerProvider from './TrackerContext';

// GOOD TO GO
const GolfTournamentProvider = React.lazy(() => import('../../../projectSpecific/golf/cnr/contexts/GolfTournamentContext'));

/** AppContext */
export const PageComponentContext = createContext();

/**
 * Wrapper for specific
 * @param {object} props 
 * @returns 
 */
const PageComponentProvider = (props) => {

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { currentSettings_state, paps_state } = states ?? {}
  const { aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});

  // papsContext 
  const { pathViews } = paps_state ?? {}
  const { organizations: organizationsKey, districts: districtsKey, sports: sportsKey } = pathViews ?? {}

  // see if any of the viewItems have a `componentContent` 
  // this settings is located at the viewItem/pageItem>pv>pageSettings under pageManagement>pages>pv
  const component_content = useMemo(() => {
    const pv = _.findLast(_.keys(pathViews), (pv) => {
      return _.get(aps_viewItems, [pv, "pageSettings", "useComponentContent"]) &&
        _.get(aps_viewItems, [pv, "pageSettings", "componentContent"]);
    });
    return pv ? _.get(aps_viewItems, [pv, "pageSettings", "componentContent"]) : null;
  }, [pathViews, aps_viewItems]);

  const providerContext = () => {

    if (component_content) {

      switch (component_content) {

        case gEnums.componentContentTypes.golfTournament:
          return <Suspense fallback={<SuspenseDimmer origin={'PageComponentContext'} />}>
            <GolfTournamentProvider fromPage={true} >
              {props.children}
            </GolfTournamentProvider>
          </Suspense>

        case gEnums.componentContentTypes.sportsOrganization:
          return <Suspense fallback={<SuspenseDimmer origin={'PageComponentContext'} />}>
            <SportsOrganizationProvider organizationsKey={organizationsKey}>
              {props.children}
            </SportsOrganizationProvider>
          </Suspense>

        case gEnums.componentContentTypes.sportsDistrict:
          return <Suspense fallback={<SuspenseDimmer origin={'PageComponentContext'} />}>
            <SportsOrganizationProvider organizationsKey={organizationsKey}>
              <SportsDistrictProvider districtsKey={districtsKey}>
                {props.children}
              </SportsDistrictProvider>
            </SportsOrganizationProvider>
          </Suspense>

        case gEnums.componentContentTypes.sportsSeason:
          return <Suspense fallback={<SuspenseDimmer origin={'PageComponentContext'} />}>
            <TrackerProvider>
              <SportsOrganizationProvider organizationsKey={organizationsKey}>
                <SportsDistrictProvider districtsKey={districtsKey}>
                  <SportsSeasonProvider sportsKey={sportsKey}>
                    {props.children}
                  </SportsSeasonProvider>
                </SportsDistrictProvider>
              </SportsOrganizationProvider>
            </TrackerProvider>
          </Suspense>

        default:
        // nothing
      }
    }

    return <PageComponentContext.Provider value={{}}>
      {props.children}
    </PageComponentContext.Provider>

  }

  return providerContext()

}

export default PageComponentProvider